import { CollectionProduct } from 'types/collection'
import { FulfillmentLocation, Product } from 'types/product'

type InventoryItem = {
  product_id: number
  product_type: string
  inventory: {
    id: string
    inventory_quantity: number
    fulfillment_location?: FulfillmentLocation
    product_id: number
    sku: string
    options: { type: string; value: string }[]
  }[]
}

export function updateVariants<T extends CollectionProduct>(
  products: T[] = [],
  variants: InventoryItem[]
) {
  return products.map(product => {
    const { id } = product

    const variantInventory = variants
      .flatMap(variant => {
        if (variant.product_id === id) {
          return variant.inventory.map(variantInventory => {
            const id = variantInventory.id.replace(
              'gid://shopify/ProductVariant/',
              ''
            )

            return { ...variantInventory, id }
          })
        }
      })
      .filter(Boolean)

    return { ...product, variants: variantInventory }
  })
}

export function getProductsWithUpdatedVariants<T extends CollectionProduct | Product>(
  products: T[] = [],
  variants: InventoryItem[]
) {
  return products.map(product => {
    const { id } = product

    const variantInventory = variants
      .flatMap(variant => {
        if (variant.product_id === id) {
          return variant.inventory.map(variantInventory => {
            const id = variantInventory.id.replace(
              'gid://shopify/ProductVariant/',
              ''
            )

            return { ...variantInventory, id }
          })
        }
      })
      .filter(Boolean)

    return { ...product, variants: variantInventory }
  })
}
